


import RouteView from '../../../Routes/RouteView';
import SurveyNavOptions, { defaultRoute } from './SurveyNavOptions';


const VirtualSurvey = ({ navoption, ModalAction }) => {
    return (
        <RouteView navoption={navoption} ModalAction={ModalAction} defaultRoute={defaultRoute}>{SurveyNavOptions}</RouteView>
    )
}



export default VirtualSurvey